import { type FC } from 'react';


import { type IconProps } from './types';

export const ArrowsProtect2OutV4Icon: FC<IconProps> = () => {
  return (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M34 33V63H64" stroke="#FFDD00" strokeWidth="2" />
      <path d="M30 0L30 30L0 30" stroke="#FFDD00" strokeWidth="2" />
    </svg>
  );
};
